import {useState} from 'react';
import Checkbox from 'components/common/checkbox.component';
import type {Translate} from 'types/myTasks';

interface BetaIntroProps {
    translate: Translate;
    onDoNotShowAgainChange: (checked: boolean) => void;
}

/**
 * Body of the "beta version" note: the intro text and the opt-out checkbox.
 */
const BetaIntro = ({translate, onDoNotShowAgainChange}: BetaIntroProps) => {

    const [doNotShowAgain, setDoNotShowAgain] = useState(false);

    const toggle = () => {
        const checked = !doNotShowAgain;
        setDoNotShowAgain(checked);
        onDoNotShowAgainChange(checked);
    };

    return (
        <>
            {/* the message is one string with blank lines between paragraphs, kept by paragraph-space */}
            <p className="paragraph-space">{translate('myTasks.overview.introMessage')}</p>
            <Checkbox
                inputId="beta-intro-do-not-show-again"
                isChecked={doNotShowAgain}
                onChange={toggle}
                label={translate('myTasks.overview.doNotShowAgain')}
                dataCy="myTasks.betaIntro.doNotShowAgain"
            />
        </>
    );
};

export default BetaIntro;
